<template>

  <main>

    <app-raster-legend
      ref="legend"
      :value="isActive && !isDynamicStyle"
      style="position: absolute; bottom: 15px; margin-left: 15px; z-index: 1;"
      layout="vertical" class="app-raster-legend"></app-raster-legend>

    <v-navigation-drawer ref="nav" app disable-resize-watcher hide-overlay mobile-break-point="0" :value="isActive" width="500">
      <v-container fluid class="pa-0">
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('busquedas') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$store.dispatch('disableControl')" :disabled="isLoading">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-container>

      <v-divider></v-divider>

      <v-container fluid class="pa-0">
        <v-card flat :color="`grey ${$store.getters.isDarkTheme ? 'darken-4' : 'lighten-4'}`" height="64">
          <div class="container-buttons">

            <v-tooltip bottom style="align-self: center;">
              <v-btn slot="activator" :disabled="isLoading" @click="isDynamicStyle = !isDynamicStyle" fab small :color="isDynamicStyle ? 'red darken-2' : 'blue darken-1'">
                <v-icon>palette</v-icon>
              </v-btn>
              <span>{{ $t('cambiar-estilo') }}</span>
            </v-tooltip>
          </div>
        </v-card>
      </v-container>

      <v-container fluid class="pa-0">
        <v-toolbar 
          style="cursor: pointer;"
          @click="collapsed = !collapsed" :color="`green ${$store.getters.isDarkTheme ? 'darken-2' : 'lighten-2'}`">
          <v-btn icon>
            <v-icon>settings</v-icon>
          </v-btn>
          <v-toolbar-title style="font-size: 16px;">{{$t('opciones')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="collapsed = !collapsed">
            <v-icon>{{collapsed ? 'add' : 'remove'}}</v-icon>
          </v-btn>
        </v-toolbar>
      </v-container>

      <v-divider :dark="$store.getters.isDarkTheme" v-if="collapsed && isDynamicStyle"></v-divider>

      <v-container fluid class="pa-0">
        <v-slide-y-transition>
          <v-card v-show="!collapsed" :color="$store.getters.isDarkTheme ? 'grey darken-4' : 'grey lighten-4'" class="px-3 pb-3">
            <v-layout row wrap>
              <v-flex xs6 class="px-2">
                <app-select-indicador
                  :disabled="disabledButtonsByDialogs"></app-select-indicador>
              </v-flex>
              <v-flex xs6 class="px-2">
                <app-select-period
                  :disabled="disabledButtonsByDialogs"></app-select-period>
              </v-flex>

              <v-flex xs6 class="px-2 pt-2">
                <app-select-ortofotos
                  :map="map"
                  :ortoLayer="LayerOrto"
                  :disabled="disabledButtonsByDialogs"></app-select-ortofotos>
              </v-flex>

              <v-flex xs6 class="px-2 pt-2">
                <app-select-raster
                  ref="rasterselect"
                  :value="isActive"
                  :disabled="disabledButtonsByDialogs"></app-select-raster>
              </v-flex>


              <v-flex xs12 class="px-2">
                <h4 class="mt-3">{{$t('comparative.compare')}}</h4>
                <app-add-polygons @changed="onChangePolygons" ref="addpolys"></app-add-polygons>
              </v-flex>
            </v-layout>

          </v-card>
        </v-slide-y-transition>
      </v-container>

      <!-- Diálogo para elegir el estilo de la capa raster -->
      <app-raster-filter
        ref="rasterfilter"
        :rasterLayer="LayerRaster" 
        :value="isDynamicStyle && isActive"></app-raster-filter>

      <v-divider :dark="$store.getters.isDarkTheme"></v-divider>

      <v-tabs
        v-if="$refs.addpolys && $refs.addpolys.polygons && $refs.addpolys.polygons.length && results"
        v-model="activeColumn"
        color="primary"
        dark
        slider-color="blue"
      >
        <v-tab
          v-for="p in $refs.addpolys.numPolygons"
          :key="`tab-${p}`"
          ripple
          v-if="$refs.addpolys.polygons[p - 1] && results && results[p - 1]"
        >
          {{$refs.addpolys.polygons[p - 1].getProperties().properties.name}}
        </v-tab>
        <v-tab-item
          v-for="p in $refs.addpolys.numPolygons"
          v-if="results[p - 1]"
          :key="`tabitem-${p}`"
        >
          <v-container grid-list-xs fluid>
            <v-layout row wrap>
              <v-flex xs6>
                <v-card height="120" flat ripple>
                  <v-card-text class="text-xs-center">
                    <v-card-actions>
                      <v-btn icon style="margin: 0px auto;">
                        <vector-polygon-icon style="font-size: 24px;"></vector-polygon-icon>
                      </v-btn>
                    </v-card-actions>
                    <h2 v-html="formattedAreas[p - 1]"></h2>
                    <span>{{$t('area-poligono')}}</span>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs6>
                <v-card height="120" flat ripple>
                  <v-card-text class="text-xs-center">
                    <v-card-actions>
                      <v-btn icon :ripple="false" style="margin: 0px auto;">
                        <v-icon>people</v-icon>
                      </v-btn>
                    </v-card-actions>
                    <h2>{{populations[p - 1] || 0}} hab.</h2>
                    <span>{{$t('poblacion-afectada')}}</span>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs6>
                <v-card height="120" flat ripple>
                  <v-card-text class="text-xs-center">
                    <v-card-actions>
                      <v-btn icon style="margin: 0px auto;">
                        <vector-polygon-icon style="font-size: 24px;"></vector-polygon-icon>
                      </v-btn>
                    </v-card-actions>
                    <h2 v-html="temperatures[p - 1][0]"></h2>
                    <span>{{$t(`comparative.${indicador}.polygon`)}}</span>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs6>
                <v-card height="120" flat ripple>
                  <v-card-text class="text-xs-center">
                    <v-card-actions>
                      <v-btn icon style="margin: 0px auto;">
                        <vector-polygon-icon style="font-size: 24px;"></vector-polygon-icon>
                      </v-btn>
                    </v-card-actions>
                    <h2 v-html="temperatures[p - 1][1]"></h2>
                    <span>{{$t(`comparative.${indicador}.extent`)}}</span>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12>
                <v-card height="120" flat ripple>
                  <v-card-text class="text-xs-center">
                    <v-card-actions>
                      <v-btn icon style="margin: 0px auto;">
                        <vector-polygon-icon style="font-size: 24px;"></vector-polygon-icon>
                      </v-btn>
                    </v-card-actions>
                    <h2 v-html="(temperatures[p - 1][0] - temperatures[p - 1][1]).toFixed(2)"></h2>
                    <span>{{$t(`comparative.${indicador}.difference`)}}</span>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
      </v-tabs>

    </v-navigation-drawer>

  </main>
</template>


<script>
import * as API from '@/api'

import SourceTileWMS from 'ol/source/tilewms'
import VectorLayer from 'ol/layer/vector'
import VectorSource from 'ol/source/vector'
import OLSphere from 'ol/sphere'

import GeomPolygon from 'ol/geom/polygon'
import Feature from 'ol/feature'
import Extent from 'ol/extent'

import AppRasterFilter from '../utils/shared-components/raster-range-filter'
import AppSelectIndicador from '../utils/shared-components/select-indicador'
import AppSelectPeriod from '../utils/shared-components/select-period'
import AppSelectRaster from '../utils/shared-components/select-raster'
import AppSelectOrtofotos from '../utils/shared-components/select-ortofoto'
import AppBufferFeature from '../utils/shared-components/buffer-feature'
import AppRasterLegend from '../utils/shared-components/raster-legend'

import AppAddPolygons from './AddPolygons'

import { LayerOrto, LayerRaster, LayerAmbito } from '../utils/layers'
import { showStyle, simpleStyle } from '../utils/style'

const LayerShow = new VectorLayer({ source: new VectorSource, style: simpleStyle })

/**
 * Componente del estilo "search" pero utilizando polígonos de búsqueda
 * para comparar sus resultados
 */
export default {

  props: ['map'],

  components: {
    AppRasterFilter,
    AppSelectIndicador,
    AppSelectPeriod,
    AppSelectRaster,
    AppSelectOrtofotos,
    AppBufferFeature,
    AppRasterLegend,
    AppAddPolygons
  },

  data() {
    return {
      /* Identificador del Componente */
      id: 'Comparative',

      isDynamicStyle: false,

      LayerRaster,
      LayerOrto,

      results: null,

      collapsed: false,

      activeColumn: null,
      polygons: [],
    }
  },

  methods: {

    checkControl(newControl, lastControl) {
      return newControl.startsWith(this.id) || lastControl.startsWith(this.id)
    },
    
    async getResultsForPolygon(feature) {
      const promises = [
        API.getPolygonStats([this.raster], feature),
        API.getRastersAverage([this.raster]),
        API.getPopulation(feature)
      ]

      let [result, ambitoStats, population] = await Promise.all(promises)

      result = result.map((value, idx) => [value, ambitoStats[idx]])

      return [result, population]
    },

    async calculate() {
        this.isLoading = true
        this.results = null
        const results = await Promise.all(this.polygons.map(this.getResultsForPolygon))
        this.isLoading = false
        this.results = results
    },

    fitMapToFeatureExtent(duration = 500) {
      if(this.polygons && this.polygons.length > 0) {
        let extents = this.polygons
          .filter(Boolean)
          .map(feature => feature.getGeometry().getExtent());
        
        let [extent, ...restExtents] = extents

        if(!restExtents) {
          return extent
        }

        for(let nExtent of restExtents) {
          extent = Extent.extend(extent, nExtent)
        }

        const constrainResolution = false
        const padding = [10, 10, 10, 10]
        const zoom = 15

        this.map.getView().fit(extent, { duration, constrainResolution, padding })
      }
    },

    paintRaster() {
      if(!this.raster) {
        return
      }

      const { name: layers, url } = this.raster
      const source = new SourceTileWMS({ url, params: { layers }, crossOrigin: 'anonymous' })
      
      LayerRaster.setSource(source)
    },

    onChangePolygons(polygons) {
      this.$nextTick(() => this.fitMapToFeatureExtent())
      this.polygons = polygons
      LayerShow.getSource().clear()
      polygons.filter(Boolean).forEach(feature => LayerShow.getSource().addFeature(feature))

      if(this.results) {
        const { length } = polygons 
        polygons.forEach(feature => feature.setStyle(simpleStyle))
        polygons[this.activeColumn || 0].setStyle(showStyle)
      }

      if(polygons.filter(Boolean).length >= 2) {  
        this.calculate()
      }
    }
  },

  computed: {

    temperatures() {
      return this.results.map(([[temperatures]]) => {
        const [ta, tb] = temperatures
        return [ta.toFixed(2), tb.avg.toFixed(2)]
      })
    },

    populations() {
      return this.results.map(([_, affectedPopulations]) => {
        if(typeof affectedPopulations == 'object') {
          const { POBLACION } = affectedPopulations
          return POBLACION
        }

        return affectedPopulations
      })
    },

    formattedAreas() {
      return this.affectedAreas.map(area => {
        let output = ''
  
        if(!area) {
          return
        }
  
        if (area > 10000) {
          output = `${(Math.round(area / 1000000 * 100) / 100)} km<sup>2</sup>`
        } else {
          output = `${(Math.round(area * 100) / 100)} m<sup>2</sup>`
        }
        
        return output
      })
    },

    affectedAreas() {
      return this.polygons.map(feature => OLSphere.getArea(feature.getGeometry()))    
    },

    linearGradient() {
      const rasterfilter = this.$refs.rasterfilter

      if(!rasterfilter) {
        return
      }

      const { minColor, maxColor, minValue, maxValue } = rasterfilter

      return { minColor, maxColor, minValue, maxValue }
    },

    raster: {
      get() { return this.$store.getters.raster },
      set(value) { this.$store.dispatch('setRaster', value) }
    },

    period() {
      return this.$store.getters.period
    },

    printDialogOpened: {
      get() { return this.$refs.print && this.$refs.print.printDialogOpened },
      set(value) { this.$refs.print.printDialogOpened = value }
    },

    disabledButtons() {
      return !!!this.results || this.isLoading
    },

    disabledButtonsByDialogs() {
      return this.isLoading
    },

    indicadores() {
      return Object.keys(this.$store.getters.indicadores)
        .map(str => str.charAt(0).toUpperCase() + str.slice(1))
    },

    isLoading: {
      get() {
        return this.$store.getters.isLoading
      },
      set(value) {
        this.$store.dispatch('setLoading', value)
      }
    },

    activeControlId() {
      return this.$store.getters.activeControlId
    },
    
    isActive() {
      return (!!this.activeControlId) && this.activeControlId.startsWith(this.id)
    },

    indicador() {
      return this.$store.getters.indicador
    },

  },

  watch: {

    activeColumn(column) {
      const features = this.polygons
      const { length } = features 
      features.forEach(feature => feature.setStyle(simpleStyle))
      features[column].setStyle(showStyle)
    },

    activeControlId(newControl, lastControl) {
      if(!this.checkControl(newControl || '', lastControl || '')) {
        return
      }

      this.map.getLayers().forEach(layer => layer.setVisible(!this.isActive))

      ;[LayerOrto, LayerRaster, LayerAmbito, LayerShow]
        .forEach(layer => layer.setMap(this.isActive ? this.map : null))


      this.isActive && this.paintRaster()
      this.isActive && this.$parent.fitIntoProjectExtent()

      LayerShow.getSource().clear()
      
      this.collapsed = false
      this.affectedPopulation = null
      this.isDynamicStyle = false
      this.results = null
      this.selectedPolygon = null
    },

    indicador() {
      if(this.isActive) {
        this.isDynamicStyle = false    
        this.calculate()
      }
    },

    raster() {
      if(this.isActive) {
        this.paintRaster()
        if(this.polygons.filter(Boolean).length >= 2) {  
          this.calculate()
        }
      }
    },

    isDynamicStyle() {
      if(!this.isDynamicStyle) {
        this.paintRaster()
      }
    },

    period() {
      if(this.isActive) {
        this.calculate()
      }
    },

  },
}
</script>


<style>
.container-buttons {
  display: flex;
  justify-content: space-around;
  height: 100%;
}

.highcharts-container {
  width:100% !important;
}
</style>



// WEBPACK FOOTER //
// Compare.vue?8a9bd7a2